import React from 'react'
import { Link } from 'react-router-dom'

function Team() {
  return (
    <div>
    <div className="section-bg section-padding subheader" style={{ backgroundImage: 'url(/tm/react/dronyug/assets/images/subheader.jpg)' }}>
    	<div className="container">
    		<div className="row">
    			<div className="col-12 text-center">
    				<h1 className="text-white page-title">Team</h1>
    			</div>
    		</div>
    	</div>
    </div>
    {/* <!-- Subheader End -->
    <!-- Team Start --> */}
    <section className="section-padding section">
        <div className="container">
            <div className="row">
                <div className="col-lg-3 col-md-6">
                    <div className="team_block">
                        <div className="team_img">
                            <img src="/tm/react/dronyug/assets/images/team/1.png" alt="img" className="image-fit"/>
                        </div>
                        <div className="team_caption">
                            <h5 className="team_name"><Link to="/team">Steven Smith</Link></h5>
                            <p className="team_post">Manager</p>
                            <button type="button" className="team_share">
                                <i className="fas fa-share-alt"></i>
                            </button>
                            <ul className="social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-linkedin-in"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div className="col-lg-3 col-md-6">
                    <div className="team_block">
                        <div className="team_img">
                            <img src="/tm/react/dronyug/assets/images/team/3.png" alt="img" className="image-fit"/>
                        </div>
                        <div className="team_caption">
                            <h5 className="team_name"><Link to="/team">Jackie Chan</Link></h5>
                            <p className="team_post">Manager</p>
                            <button type="button" className="team_share">
                                <i className="fas fa-share-alt"></i>
                            </button>
                            <ul className="social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-linkedin-in"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div className="col-lg-3 col-md-6">
                    <div className="team_block">
                        <div className="team_img">
                            <img src="/tm/react/dronyug/assets/images/team/2.png" alt="img" className="image-fit"/>
                        </div>
                        <div className="team_caption">
                            <h5 className="team_name"><Link to="/team">Vimal Gurjar</Link></h5>
                            <p className="team_post">Manager</p>
                            <button type="button" className="team_share">
                                <i className="fas fa-share-alt"></i>
                            </button>
                            <ul className="social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-linkedin-in"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
               
                <div className="col-lg-3 col-md-6">
                    <div className="team_block">
                        <div className="team_img">
                            <img src="/tm/react/dronyug/assets/images/team/4.png" alt="img" className="image-fit"/>
                        </div>
                        <div className="team_caption">
                            <h5 className="team_name"><Link to="/team">Chris Hemsworth</Link></h5>
                            <p className="team_post">Manager</p>
                            <button type="button" className="team_share">
                                <i className="fas fa-share-alt"></i>
                            </button>
                            <ul className="social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-linkedin-in"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
               
                <div className="col-lg-3 col-md-6">
                    <div className="team_block">
                        <div className="team_img">
                            <img src="/tm/react/dronyug/assets/images/team/5.png" alt="img" className="image-fit"/>
                        </div>
                        <div className="team_caption">
                            <h5 className="team_name"><Link to="/team">Kevin Peterson</Link></h5>
                            <p className="team_post">Manager</p>
                            <button type="button" className="team_share">
                                <i className="fas fa-share-alt"></i>
                            </button>
                            <ul className="social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-linkedin-in"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
               
                <div className="col-lg-3 col-md-6">
                    <div className="team_block">
                        <div className="team_img">
                            <img src="/tm/react/dronyug/assets/images/team/6.png" alt="img" className="image-fit"/>
                        </div>
                        <div className="team_caption">
                            <h5 className="team_name"><Link to="/team">Jacks Cock</Link></h5>
                            <p className="team_post">Manager</p>
                            <button type="button" className="team_share">
                                <i className="fas fa-share-alt"></i>
                            </button>
                            <ul className="social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-linkedin-in"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
               
                <div className="col-lg-3 col-md-6">
                    <div className="team_block">
                        <div className="team_img">
                            <img src="/tm/react/dronyug/assets/images/team/7.png" alt="img" className="image-fit"/>
                        </div>
                        <div className="team_caption">
                            <h5 className="team_name"><Link to="/team">Jhon Cena</Link></h5>
                            <p className="team_post">Manager</p>
                            <button type="button" className="team_share">
                                <i className="fas fa-share-alt"></i>
                            </button>
                            <ul className="social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-linkedin-in"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
               
                <div className="col-lg-3 col-md-6">
                    <div className="team_block">
                        <div className="team_img">
                            <img src="/tm/react/dronyug/assets/images/team/8.png" alt="img" className="image-fit"/>
                        </div>
                        <div className="team_caption">
                            <h5 className="team_name"><Link to="/team">Roman Reings</Link></h5>
                            <p className="team_post">Manager</p>
                            <button type="button" className="team_share">
                                <i className="fas fa-share-alt"></i>
                            </button>
                            <ul className="social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-linkedin-in"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <nav>
                        <ul className="pagination">
                            <li className="page-item">
                                <Link className="page-link" to="#" aria-label="Previous">
                                    <span aria-hidden="true">«</span>
                                    <span className="sr-only">Previous</span>
                                </Link>
                            </li>
                            <li className="page-item active"><Link className="page-link" to="#">1</Link></li>
                            <li className="page-item"><Link className="page-link" to="#">2</Link></li>
                            <li className="page-item"><Link className="page-link" to="#">3</Link></li>
                            <li className="page-item">
                                <Link className="page-link" to="#" aria-label="Next">
                                    <span aria-hidden="true">»</span>
                                    <span className="sr-only">Next</span>
                                </Link>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default Team